export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7403.dc8aaa42.jpg";